import styled from 'styled-components';

export const StyledPremiumRoadmapContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledPremiumRoadmapCareerPaths = styled.div<{ $isSmall?: boolean }>`
  margin-top: 9.2rem;
  margin-bottom: 4.6rem;
  display: flex;
  gap: 2rem;
  width: 100%;
  justify-content: center; // Center by default for smaller screens
  align-items: flex-start;

  > div {
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    justify-content: space-between; // Switch to space-between for 3-column layout
    align-items: stretch;
    gap: 4rem;

    > div {
      width: calc((100% - 8rem) / 3);
      min-width: calc((100% - 8rem) / 3);
      max-width: calc((100% - 8rem) / 3);
      padding-bottom: 1.6rem; // Reduced from 3rem to 1.6rem

      &::after {
        content: '';
        flex: 1;
        min-height: 1.6rem; // Reduced from 3rem to 1.6rem to match padding
      }
    }
  }
`;

export const StyledPathCardGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.6rem;
  flex-wrap: wrap;
  align-content: center;
  position: relative;
`;

export const StyledGridPathCardGroup = styled(StyledPathCardGroup)<{
  isDisplayOnePathOnWelcomeEnabled?: boolean;
}>`
  width: 100%;
  padding-bottom: 0; // Remove padding that affects arrow positioning

  > div {
    &:last-child {
      margin-bottom: 0; // Remove margin from last card to not affect arrow
      padding-bottom: ${({ isDisplayOnePathOnWelcomeEnabled }) =>
        isDisplayOnePathOnWelcomeEnabled ? '0' : '3rem'}; // Move padding to last child only
    }
  }
`;

export const StyledComputerScienceBasicsContainer = styled.div`
  margin-bottom: 4.6rem;
`;

export const StyledCyberSecurityFoundationsContainer = styled.div`
  margin-top: 10rem;
  margin-bottom: 4.6rem;
`;

export const StyledCyberSecurityCareerSkillsContainer = styled.div`
  margin-top: 10rem;
`;

export const StyledWhatsNext = styled.div`
  margin-top: 7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  p {
    margin-top: 1rem;
  }
  p:first-child {
    font-size: 2.2rem;
    font-weight: ${({ theme }) => theme.fonts.weight.semiBold};
  }
  button {
    margin-top: 2rem;
    color: #eeeff2;
  }
`;

export const StyledArrowAnchor = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
`;

export const StyledInfoCardWrapper = styled.div<{ $isSmall?: boolean }>`
  margin-bottom: 4.6rem;
`;
